import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { isMobile } from 'react-device-detect'
import { makeStyles } from '@material-ui/styles';
import "./payments.scss";
import ArrowBack from '../../components/ArrowBack/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import BillingForm from "../../components/BillingForm/BillingForm";
import BillingSummary from "../../components/BillingSummary/BillingSummary";
import BillingPaymentForm from '../../components/BillingPaymentForm/BillingPaymentForm'
//import { getBillingLaywers } from "../../store/actions/billingAction";
import { setMemeshipInfo } from "../../store/actions/UserAction";
import { updateBillingLaywers } from "../../store/actions/billingAction";
import { Grid } from '@material-ui/core';
import ArrowBackStandar from '../../components/ArrowBack/ArrowBackStandar';
import { flex, margin } from 'styled-system';
import ButtonBase from "../../components/Buttons/ButtonBase";
import Lottie from 'lottie-react-web';
// import escritorio_Premium from "../../animations/premium/escritorio_Premium.json";
// import mobile_premium from "../../animations/premium/mobile_premium.json";
import escritorio_premium_plus from "../../animations/plus/escritorio_premium_plus.json";
import mobile_Premium_Plus from "../../animations/plus/mobile_Premium_Plus.json";



const useStyles = makeStyles({
    item: {
        width: isMobile ? '95%' : 'initial'
    }
})

const Payments = (props) => {

    const [checkout, setCheckout] = useState(false)
    const history = useHistory();
    const breakpoint = useMediaQuery('(min-width:768px)');
    const { billing, setMemeshipInfo, membershipType, updateBillingLaywers, laywerUid } = props
    const handleBackData = () => {
        history.push('/dashboard/membresia')
    };

    const classes = useStyles()

    useEffect(() => {
        handleGetBillingLaywer()

        if (Object.entries(billing).length !== 0 && !billing.billingForm) {
            return function reset() {
                /*  handleEditBilling(); */
            }
        }

    }, [billing.billingForm]);

    const handleGetBillingLaywer = async () => {
        //let data = await props.getBillingLaywers(props.laywerUid);
        //console.log("data", data );
    }

    // const desktopPremium = {
    //     loop: true,
    //     autoplay: true,
    //     animationData: escritorio_Premium,
    //     rendererSettings: {
    //         preserveAspectRatio: 'xMidYMid slice'
    //     }
    // };

    // const mobilepPremium = {
    //     loop: true,
    //     autoplay: true,
    //     animationData: mobile_premium,
    //     rendererSettings: {
    //         preserveAspectRatio: 'xMidYMid slice'
    //     }
    // };

    const desktopPremiumPlus = {
        loop: true,
        autoplay: true,
        animationData: escritorio_premium_plus,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    const mobilepPremiumPlus = {
        loop: true,
        autoplay: true,
        animationData: mobile_Premium_Plus,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    const handleEditBilling = () => {
        console.log('regresar')
        let data = {
            ...billing,
            billingForm: true,
        }

        updateBillingLaywers(laywerUid, data)
    }

    const handleCheckout = () => {
        console.log('test 1')

        setMemeshipInfo(props.laywerUid, props.modalPayments)
        setCheckout(true)

    }
    const CheckoutInfo = (props) => {

        return (
            <div style={{
                width: '100%',
                height: 'auto',
                borderRadius: 4,
                boxShadow: ' 0 2px 4px 0 rgba(0, 0, 0, 0.12)',
                backgroundColor: 'white'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

                    <div className="hide-mobile">
                        {props.membershipType == 'Premium' &&
                            <Lottie options={desktopPremiumPlus}
                                height={'100%'}
                                width={'100%'}
                            />
                        }
                    </div>
                    <div className="hide-tablet">
                        {props.membershipType == 'Premium' &&
                            <Lottie options={mobilepPremiumPlus}
                                height={'100%'}
                                width={'100%'}
                            />
                        }
                    </div>


                    <div className='subtitle_checkout'>
                    Comienza a explorar nuestros beneficios.
                        </div>

                </div>
                <div style={{
                    display: 'flex', margin: '43px 0',
                    justifyContent: 'space-between', flexWrap: 'wrap', padding: '0px 44px'
                }}>
                    <div className={'cardMid'}>
                        <div className='logoIcon'><img src='/img/payment/profile_icon.svg' alt='' /></div>
                        <div className='titleCard'>Mi perfil público</div>
                        <div className='textCard'>Inicia llenado tu perfil para que clientes potenciales
                            puedan contactarte.</div>
                        <div style={{ width: '100%', marginTop: 31 }}>
                            <ButtonBase
                                style={{ width: '100%' }}
                                type="submit"
                                onClick={() => { history.push('/dashboard/perfil') }}
                                className="buttonNext"
                                variant="secondary" >
                                Completar mi perfil
                            </ButtonBase>
                        </div>
                    </div>
                    <div className={'cardMid'}>
                        <div className='logoIcon'><img src='/img/payment/card_icon.svg' alt='' /></div>
                        <div className='titleCard'>Detalles de membresía</div>
                        <div className='textCard'>Ingresa para ver detalles de tu membresía, como fecha de facturación.</div>
                        <div style={{ width: '100%', marginTop: 31 }}>
                            <ButtonBase
                                style={{ width: '100%' }}
                                type="submit"
                                onClick={() => { history.push('/dashboard/membresia') }}
                                className="buttonNext"
                                variant="secondary"
                            >
                                Ir a mi membresía
                            </ButtonBase>
                        </div>



                    </div>
                    <div className={'cardMid'}>
                        <div className='logoIcon'><img src='/img/payment/card_icon.svg' alt='' /></div>
                        <div className='titleCard'>Tour de sitio</div>
                        <div className='textCard'>Mira una guía rápida de todos los beneficios y usos que te brinda Contacta Abogado®</div>
                        <div style={{ width: '100%', marginTop: 31 }}>
                            <ButtonBase
                                style={{ width: '100%' }}
                                type="submit"
                                onClick={() => { history.push('/dashboard') }}
                                className="buttonNext"
                                variant="secondary"

                            >
                                Ver tour de sitio
                            </ButtonBase>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    return (
        <div className="contentMainPayments">
            {checkout ? (<CheckoutInfo membershipType={membershipType} />) : (
                <Grid container direction="row" justify="center">
                    <Grid item className={classes.item}>
                        <div style={{ position: 'absolute', marginTop: 24 }} /* onClick={()=> handleEditBilling()} */>
                            <ArrowBackStandar text="Regresar" />
                        </div>
                        {Object.entries(billing).length === 0 || (Object.entries(billing).length !== 0 && billing.billingForm === false) ? <BillingForm /> : <BillingPaymentForm handleCheckout={handleCheckout} />}
                    </Grid>
                    <Grid item className={classes.item}>
                        <BillingSummary />
                    </Grid>
                </Grid>
            )}

        </div>
    );
};
const mapDispatchToProps = dispatch => ({
    setMemeshipInfo: (laywerUid, modalPayments) => dispatch(setMemeshipInfo(laywerUid, modalPayments)),
    updateBillingLaywers: (laywerUid, data) => dispatch(updateBillingLaywers(laywerUid, data)),
    //getBillingLaywers: (laywerUid) => dispatch(getBillingLaywers(laywerUid)),
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    modalPayments: state.ModalReducer.openModalPayments,
    role: state.authClient.role,
    membershipType: state.authClient.membership.type,
    billing: state.billingReducer.billingData ? state.billingReducer.billingData : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Payments);